import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux'
import { AUTH_CONFIG } from '../../../../Auth/auth0-variables';
import axios from 'axios';
import htmr from 'htmr';
class Announcement extends Component {
    constructor(props) {
        super(props);

        this.state = {
           
            loading: false,
            spinner: false,
            message: '',
            rows: 1,
            item: {}
        };
        this.messagesEndRef = React.createRef();
        this.fileUploadImageRef = React.createRef();
        this.fileUploadFileRef = React.createRef();
    }
    
    render() {
        
        return (
            <div className="displayflex flexcolumn chat height100" style={{ position: 'relative', }}>
                <div className="custom-scrollbar mb10 height100 p20" style={{maxWidth:1000} }>
                    <div className="flex-row spacebetween mb10">
                        <p className="label-small">{this.props.facilityName}</p>
                        <p className="label-small">{this.props.item.createdOn}</p>
                    </div>
                    <h4 className="head-m mb10" style={{ color: "var(--palette-black-alpha-100)" }}>{this.props.item.title}</h4>
                    <p className="mb30">{htmr(this.props.item.description)}</p>
                    {this.props.item.attachments.map((a, i) => {
                        return <a href={AUTH_CONFIG.CDN_URL + '/files/' + a.attachment} target="_blank" rel="noreferrer">
                            <div className="attachment-pill mt10" style={{ justifyContent: 'flex-start' }} onClick={() => { }}>
                            {!a.attachment.match(/.(jpg|jpeg|png|gif)$/i) &&
                                <svg role="presentation" viewBox="0 0 32 32" focusable="false" style={{ width: 25, marginRight: 5 }}>
                                    <g class="app-files-icon">
                                        <path d="M6.5 29H25.5C25.775 29 26 28.775 26 28.5V9H21.5C20.673 9 20 8.327 20 7.5V3H6.5C6.225 3 6 3.225 6 3.5V28.5C6 28.775 6.225 29 6.5 29Z" fill="white"></path>
                                        <path d="M25.293 8.00003L21 3.70703V7.50003C21 7.77503 21.225 8.00003 21.5 8.00003H25.293Z" fill="white"></path>
                                        <path opacity="0.64" fill-rule="evenodd" clip-rule="evenodd" d="M26.56 7.854L21.146 2.439C20.8642 2.15891 20.4833 2.00117 20.086 2H6.5C5.673 2 5 2.673 5 3.5V28.5C5 29.327 5.673 30 6.5 30H25.5C26.327 30 27 29.327 27 28.5V8.914C27 8.514 26.844 8.137 26.56 7.854ZM21 3.707L25.293 8H21.5C21.2241 7.99945 21.0005 7.77591 21 7.5V3.707ZM6.5 29H25.5C25.775 29 26 28.775 26 28.5V9H21.5C20.673 9 20 8.327 20 7.5V3H6.5C6.225 3 6 3.225 6 3.5V28.5C6.00055 28.7759 6.22409 28.9995 6.5 29Z" fill="#605E5C"></path>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M23.5 13H8.5C8.22386 13 8 12.7761 8 12.5C8 12.2239 8.22386 12 8.5 12H23.5C23.7761 12 24 12.2239 24 12.5C24 12.7761 23.7761 13 23.5 13ZM23.5 15H8.5C8.22386 15 8 14.7761 8 14.5C8 14.2239 8.22386 14 8.5 14H23.5C23.7761 14 24 14.2239 24 14.5C24 14.7761 23.7761 15 23.5 15ZM8.5 17H23.5C23.7761 17 24 16.7761 24 16.5C24 16.2239 23.7761 16 23.5 16H8.5C8.22386 16 8 16.2239 8 16.5C8 16.7761 8.22386 17 8.5 17Z" fill="#C8C6C4"></path>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M13 19H19C20.1046 19 21 19.8954 21 21V25C21 26.1046 20.1046 27 19 27H13C11.8954 27 11 26.1046 11 25V21C11 19.8954 11.8954 19 13 19ZM20 21C20 20.449 19.551 20 19 20H13C12.449 20 12 20.449 12 21V25C12 25.551 12.449 26 13 26H19C19.551 26 20 25.551 20 25V21ZM5 26H9.75C9.88807 26 10 25.8881 10 25.75V20.25C10 20.1119 9.88807 20 9.75 20H5C4.44772 20 4 20.4477 4 21V25C4 25.5523 4.44772 26 5 26ZM22.25 20H27C27.5523 20 28 20.4477 28 21V25C28 25.5523 27.5523 26 27 26H22.25C22.112 26 22 25.888 22 25.75V20.25C22 20.1119 22.1119 20 22.25 20Z" fill="#D65532"></path>
                                    </g>
                                </svg>
                            }
                            {a.attachment.match(/.(jpg|jpeg|png|gif)$/i) &&

                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" style={{ width: 25, marginRight: 5 }}><path fill="#FFF" d="M3.5 17h13c.275 0 .5-.225.5-.5v-13c0-.275-.225-.5-.5-.5h-13c-.275 0-.5.225-.5.5v13c0 .275.225.5.5.5z" /><path fill="none" stroke="#A6CCC3" stroke-miterlimit="10" d="M11.691 10.657l-.878 1.286-1.687-2.326a1 1 0 00-1.619 0l-2.39 3.296a1 1 0 00.81 1.587h8.146a1 1 0 00.826-1.564l-1.556-2.28a1 1 0 00-1.652 0z" /><circle fill="none" stroke="#FF9810" stroke-miterlimit="10" cx="13.5" cy="6.5" r="1" /><path opacity=".64" fill="#605E5C" d="M16.5 18h-13c-.827 0-1.5-.673-1.5-1.5v-13C2 2.673 2.673 2 3.5 2h13c.827 0 1.5.673 1.5 1.5v13c0 .827-.673 1.5-1.5 1.5zM3.5 3a.5.5 0 00-.5.5v13a.5.5 0 00.5.5h13a.5.5 0 00.5-.5v-13a.5.5 0 00-.5-.5h-13z" /></svg>
                            }
                            <span className="name">{a.attachment}</span>
                            </div>
                            </a>
                    })}

                   
                    {this.props.item.required && this.props.planType !== 'Free' && (this.props.user.userType == '1' || this.props.user.userType == '2') &&
                        <div className="flex-row mt10">
                            {(this.props.item.users.length > 0) &&
                            <div className="required-pill-large p5" onClick={() => this.props.callback(7, 1, this.props.item.announcementId, this.props.item)}><i class="ms-Icon ms-Icon--CompletedSolid"></i> {this.props.item.users.filter(x => x.seen).length}/{this.props.item.users.length} Staff Have Reviewed</div>
                            }
                        </div>
                    }
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const facilityId = state.appState.product.facility.facilityID;
    const product = state.appState.product.slug
    const user = state.userProfile;
    const facilityName = state.appState.product.facility.name;
    const userId = state.userProfile.userId;
    const planType = state.appState.planType;

    return {
        facilityId,
        user,
        product,
        facilityName,
        userId,
        planType
    }
}


export default connect(mapStateToProps)(Announcement);

